export const UI_GLASS_ENABLED_CLASS = 'ui-glass-enabled'
